import { InjectionKey } from 'vue';
import { RepositoryFactory, Repositories } from '@/repositories/RepositoryFactory';

const LiffRepository = RepositoryFactory.get('liff') as Repositories['liff'];

export const useLiff = () => {
  /**
   * LIFFで得たidTokenを元にサーバーサイドで顧客を特定し、セッションを確立する
   * @param idToken
   * @param gwKey 流入経路分析用(ゲートウェイ)キー
   * @see https://developers.line.biz/ja/reference/liff/#get-id-token
   */
  const login = async (idToken: string, gwKey: string | null) => {
    return await LiffRepository.login(idToken, gwKey);
  };

  return {
    login,
  };
};

type LiffType = ReturnType<typeof useLiff>;
export const LiffKey: InjectionKey<LiffType> = Symbol('Liff');
